import { initializeApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider } from 'firebase/auth';

// Set this to true for testing without Firebase
const isTestMode = import.meta.env.VITE_TEST_MODE === 'true';

// Declare the variables first
let auth: any;
let googleProvider: any;

if (isTestMode) {
  // In test mode, use minimal Firebase config
  const testConfig = {
    apiKey: 'test-api-key',
    authDomain: 'test-project.firebaseapp.com',
    projectId: 'test-project',
    storageBucket: 'test-project.appspot.com',
    messagingSenderId: '123456789',
    appId: 'test-app-id'
  };
  
  try {
    const app = initializeApp(testConfig);
    auth = getAuth(app);
    googleProvider = new GoogleAuthProvider();
    googleProvider.setCustomParameters({ prompt: 'select_account' });
    googleProvider.addScope('profile');
    googleProvider.addScope('email');
  } catch (error) {
    console.error('Test mode Firebase initialization error:', error);
    throw error;
  }
} else {
  // Validate required environment variables
  const requiredEnvVars = [
    'VITE_FIREBASE_API_KEY',
    'VITE_FIREBASE_AUTH_DOMAIN',
    'VITE_FIREBASE_PROJECT_ID',
    'VITE_FIREBASE_STORAGE_BUCKET',
    'VITE_FIREBASE_MESSAGING_SENDER_ID',
    'VITE_FIREBASE_APP_ID'
  ];

  const missingEnvVars = requiredEnvVars.filter(varName => !import.meta.env[varName]);
  if (missingEnvVars.length > 0) {
    console.error('Missing Firebase environment variables:', missingEnvVars);
    throw new Error(
      `Missing required Firebase environment variables: ${missingEnvVars.join(', ')}\n` +
      'Please check your .env file and make sure all required variables are set.'
    );
  }

  const firebaseConfig = {
    apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
    authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
    projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
    storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
    messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
    appId: import.meta.env.VITE_FIREBASE_APP_ID
  };

  try {
    // Initialize Firebase
    const app = initializeApp(firebaseConfig);
    
    // Initialize Auth
    auth = getAuth(app);
    
    // Initialize Google Provider
    googleProvider = new GoogleAuthProvider();
    
    // Basic configuration
    googleProvider.setCustomParameters({
      prompt: 'select_account'
    });
    
    // Add required scopes
    googleProvider.addScope('profile');
    googleProvider.addScope('email');
    
  } catch (error) {
    console.error('Firebase initialization error:', error);
    // Fallback to test mode if initialization fails
    const testConfig = {
      apiKey: 'test-api-key',
      authDomain: 'test-project.firebaseapp.com',
      projectId: 'test-project',
      storageBucket: 'test-project.appspot.com',
      messagingSenderId: '123456789',
      appId: 'test-app-id'
    };
    
    try {
      const app = initializeApp(testConfig);
      auth = getAuth(app);
      googleProvider = new GoogleAuthProvider();
      googleProvider.setCustomParameters({ prompt: 'select_account' });
      googleProvider.addScope('profile');
      googleProvider.addScope('email');
    } catch (fallbackError) {
      console.error('Fallback Firebase initialization failed:', fallbackError);
      // Create minimal mock objects
      auth = {
        signOut: () => Promise.resolve(),
        currentUser: null
      };
      googleProvider = {
        addScope: () => googleProvider,
        setCustomParameters: () => googleProvider
      };
    }
  }
}

export { auth, googleProvider };
